<template lang="pug">
  div.base-definition-list
    div.base-definition-list
      dl.base-definition-list__dl(v-for="item,i in items" :key="'item'+i" :class="[classDisplay]")
        dt.base-definition-list__dt(:class="[keysAlign]") {{ item.key }}
        dd.base-definition-list__dd(:class="[valuesAlign]")
          template(v-if="showAsChips(item)")
            v-chip.ma-2(v-for="text,j in itemsArray(item.value)" :key="'text'+j" :color="setColor(item)" dark) {{ text }}
          template(v-else)
            p.ma-0(v-for="text,j in itemsArray(item.value)" :key="'text'+j") {{ text }}
</template>

<script>
  export default {
    name: "BaseDefinitionList",
    props: {
      items: {
        type: Array,
        default: function(){
          return []
        }
      },
      keysAlign: {
        type: String,
        default: ''
      },
      valuesAlign: {
        type: String,
        default: ''
      },
      display: {
        type: String,
        default: ''
      },
    },
    data:() => ({
    }),
    computed: {
      classDisplay(){
        if (this.valuesAlign == '4/8'){
          return 'base-definition-list--48';
        } else if (this.valuesAlign == '8/4'){
          return 'base-definition-list--84';
        } else {
          // default 6/6
          return 'base-definition-list--66';
        }
      },
    },
    methods:{
      itemsArray(val){
        if(typeof val == 'undefined'){
          return [''];
        } else if(typeof val == 'string' || typeof val == 'number'){
          return [val];
        } else if(typeof val == 'object' && Array.isArray(val)){
          return val;
        }
      },
      showAsChips(item){
        return item.type == 'chip';
      },
      setColor(item){
        if(item.color){
          return item.color(item);
        } else {
          return 'primary';
        }
      }
    },
  }
</script>

<style lang="sass">
.base-definition-list
  &__dl
    display: flex
    margin-left: -12px
    margin-right: -12px
    flex-wrap: wrap
    &:hover
      background-color: #eee
  &__dt
    font-weight: 600
    flex: 0 0 100%
    padding: 4px 12px
  &__dd
    flex: 0 0 100%
    padding: 4px 12px
  &--48
    @media (min-width: 600px)
      .base-definition-list
        &__dt
          flex: 0 0 33.3333333333%
        &__dd
          flex: 0 0 66.666666666%
  &--66
    @media (min-width: 600px)
      .base-definition-list
        &__dt
          flex: 0 0 50%
        &__dd
          flex: 0 0 50%
  &--84
    @media (min-width: 600px)
      .base-definition-list
        &__dt
          flex: 0 0 66.666666666%
        &__dd
          flex: 0 0 33.3333333333%
</style>